import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import * as ReactDOM from 'react-dom';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkSelectInput from '../../widgets/ReactSparkSelectInput';
import ConfigurationList from '../../widgets/ConfigurationList';
import {
    accessibilityFilterVisibility,
    accessibilityFilterUnchecked,
    usePointsFilterUnchecked,
    usePointsFilterVisibility,
    productSegmentationFilter,
    requestedRatesSorting
} from '../../../constants/configurationListItems';
import { getText } from '../../../../lib/utils';
import { ACCESSIBILITY_FILTER_VISIBILITY } from '../../../constants/AccessibilityTypes';
import { USE_POINTS_FILTER_VISIBILITY } from '../../../constants/UsePointsTypes';
import If from '../../helpers/if';

class FilterConfiguration extends Component {
    constructor() {
        super(...arguments);
        this.sections = [];
    }

    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }

    registerSection(key) {
        return node => (this.sections[key] = node);
    }

    sectionStyleHandler(key) {
        return this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(key) === -1
            ? { display: 'none' }
            : {};
    }

    componentDidMount() {
        if (this.props.onIndex) {
            this.sections.forEach((section, key) => {
                this.props.onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }

    _getDefaultDropdownValue = (collection, defaultValue) => {
        const optionKeys = _.map(collection, option => option.key);

        return optionKeys.includes(defaultValue) ? defaultValue : collection[0].key;
    }

    render() {
        const hotelFields = [
            { name: 'Brands', code: 'brands' },
            { name: 'Destinations', code: 'destinations' }
        ];
        const productFields = [
            { name: 'Room Views', code: 'roomViews' },
            { name: 'Rooms and Suites', code: 'roomsAndSuites' },
            { name: 'Bed Type', code: 'bedType' },
            { name: 'Rate Type', code: 'rateType' },
            { name: 'Room Category', code: 'roomCategory' },
            { name: 'Room Features', code: 'feature' },
            { name: 'Room Type', code: 'roomType' },
            { name: 'Price', code: 'price' },
            { name: 'Show points', code: 'showPoints' }
        ];
        const accessibilityVisibility = _.get(this.props, 'currentConfigCopy.accessibilityFilter.visibility');
        const defaultAccessibilityFilterVisibility = this._getDefaultDropdownValue(accessibilityFilterVisibility, accessibilityVisibility);

        const usePointsVisibility = _.get(this.props, 'currentConfigCopy.usePointsFilter.visibility');
        const defaultUsePointsFilterVisibility = this._getDefaultDropdownValue(usePointsFilterVisibility, usePointsVisibility);

        const configProductSegmentationFilter = _.get(this.props, 'currentConfigCopy.productSegmentationFilter');
        const defaultProductSegmentationFilter = this._getDefaultDropdownValue(productSegmentationFilter, configProductSegmentationFilter);

        const currentRequestedRatesSorting = _.get(this.props, 'currentConfigCopy.requestedRatesSorting');
        const defautltRequestedRatesSorting = this._getDefaultDropdownValue(requestedRatesSorting, currentRequestedRatesSorting);

        const isDisabled = _.get(this.props, 'isDisabled', false);
        return (
            <div className="spark-panel__content col-xs-12">
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(0)}
                    style={this.sectionStyleHandler(0)}
                >
                    <div className="col-xs-12">
                        <h3>Filter Settings</h3>
                        <h4>Special Codes and Rates Options</h4>
                        <ConfigurationCheckbox
                            ref={this.registerSection(0)}
                            style={this.sectionStyleHandler(0)}
                            title="Show the rate filter select list for guests to choose special rates that the property offers."
                            isDisabled={isDisabled}
                            code="showRateFilters"
                            onChange={this.props.toggleConfigBoolean}
                            value={_.get(this.props, 'currentConfigCopy.showRateFilters')}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(1)}
                            style={this.sectionStyleHandler(1)}
                            isDisabled={isDisabled}
                            title="Expand Special Codes and Rates section."
                            code="expandSpecialCodesAndRates"
                            onChange={this.props.toggleConfigBoolean}
                            value={_.get(this.props, 'currentConfigCopy.expandSpecialCodesAndRates')}
                        />
                        <ConfigurationCheckbox
                          ref={this.registerSection(2)}
                          style={this.sectionStyleHandler(2)}
                          isDisabled={isDisabled}
                          title="Show Member Rates when Special Codes apply and other available rates are hidden."
                          code="showMemberRatesWhenOtherAvailableRatesAreHidden"
                          onChange={this.props.toggleConfigBoolean}
                          value={_.get(this.props, 'currentConfigCopy.showMemberRatesWhenOtherAvailableRatesAreHidden')}
                        />
                        <If condition={this.props.inContextBeta}>
                            <section
                                className="row spark-panel__content incontext-container"
                                ref={this.registerSection(10)}
                                style={this.sectionStyleHandler(10)}
                            >
                                <div className="col-xs-12">
                                    <h4 className="spark-margin-bottom--lg">In-Context Options</h4>
                                    <ConfigurationCheckbox
                                        title="Show Promo Code option "
                                        isDisabled={isDisabled}
                                        code="showPromoOrGroupCode"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={_.get(this.props, 'currentConfigCopy.showPromoOrGroupCode')}
                                    />
                                    <ConfigurationCheckbox
                                        title="Show Group Code option"
                                        isDisabled={isDisabled}
                                        code="showGroupCodeOption"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={_.get(this.props, 'currentConfigCopy.showGroupCodeOption')}
                                    />
                                    <ConfigurationCheckbox
                                        title="Show Agent ID (IATA) option"
                                        isDisabled={isDisabled}
                                        code="showAgentId"
                                        onChange={this.props.toggleConfigBoolean}
                                        value={_.get(this.props, 'currentConfigCopy.showAgentId')}
                                    />
                                </div>
                            </section>
                        </If>
                        <h6>
                            The options below define how guests can see results for promo, IATA, and special rates. If
                            unchecked, guests will not see other available public rates.
                        </h6>
                        <ConfigurationCheckbox
                            ref={this.registerSection(2)}
                            style={this.sectionStyleHandler(2)}
                            title="Show other available rates when rate filters are provided."
                            isDisabled={isDisabled}
                            code="showAllAvailableRatesWithRateFilters"
                            onChange={this.props.toggleConfigBoolean}
                            value={_.get(this.props, 'currentConfigCopy.showAllAvailableRatesWithRateFilters')}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(1)}
                            style={this.sectionStyleHandler(1)}
                            title="Show other available rates when promotion, group, or corporate code is provided."
                            isDisabled={isDisabled}
                            code="showAllAvailableRatesWithPromo"
                            onChange={this.props.toggleConfigBoolean}
                            value={_.get(this.props, 'currentConfigCopy.showAllAvailableRatesWithPromo')}
                        />
                        <ConfigurationCheckbox
                            ref={this.registerSection(3)}
                            style={this.sectionStyleHandler(3)}
                            title="Show other available rates when IATA code is provided."
                            isDisabled={isDisabled}
                            code="showAllAvailableRatesWithIata"
                            onChange={this.props.toggleConfigBoolean}
                            value={_.get(this.props, 'currentConfigCopy.showAllAvailableRatesWithIata')}
                        />
                        <h6>
                            Select a sorting option for public requested rates. Note that requested private rates will always be displayed above public rates.
                        </h6>
                        <ReactSparkSelectInput
                            label="Select requested public rates sorting behavior"
                            isDisabled={isDisabled}
                            defaultValue={defautltRequestedRatesSorting}
                            values={requestedRatesSorting.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            onChange={event => {
                                const obj = requestedRatesSorting.find(elem => {
                                    return elem.key === event.target.value;
                                });
                                this.props.setConfigText('requestedRatesSorting', _.get(obj, 'key'));
                            }}
                        />
                    </div>
                </section>
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(1)}
                    style={this.sectionStyleHandler(1)}
                >
                    <div className="col-xs-12">
                        <h4>Product Segments</h4>
                        <p className="without-margin">
                            <span>
                                Use segments to promote a specific product attribute. Segments are part of the filter
                                bar.
                            </span>
                            <br />
                            <span>
                                Select a category to show rooms by sub-category (eg Rate Type > AAA, VA, Member).
                            </span>
                            <br />
                            <b>Categories and Sub-categories are defined in Control Center.</b>
                        </p>
                        <p className="image-info-container">
                            <div className="left icon-wrapper">
                                <i className="spark-icon--fill spark-icon-note spark-icon--md" />
                            </div>
                            <span className="text-wrapper">
                                <span className="spark-bold">
                                    Match segments to your project <Link to="/pages/product/settings">list view</Link>
                                </span>
                                <br />
                                <span>Room category segment might not be optimal with category view, for example.</span>
                            </span>
                        </p>
                        <ReactSparkSelectInput
                            label="Segment Category"
                            isDisabled={isDisabled}
                            defaultValue={defaultProductSegmentationFilter}
                            values={productSegmentationFilter.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            onChange={event => {
                                const obj = productSegmentationFilter.find(elem => {
                                    return elem.key === event.target.value;
                                });
                                this.props.setConfigText('productSegmentationFilter', _.get(obj, 'key'));
                            }}
                        />
                    </div>
                </section>
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(2)}
                    style={this.sectionStyleHandler(2)}
                >
                    <div className="col-xs-12">
                        <h4>Accessibility Filters</h4>
                        <ReactSparkSelectInput
                            label="Select the placement of the Accessibility filter"
                            isDisabled={isDisabled}
                            defaultValue={defaultAccessibilityFilterVisibility}
                            values={accessibilityFilterVisibility.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            onChange={event => {
                                const selectedOption = accessibilityFilterVisibility.find(elem => elem.key === _.get(event, 'target.value'));
                                const visibilityValue = _.get(selectedOption, 'key');
                                const isDontShowAccessibleFilters = visibilityValue === ACCESSIBILITY_FILTER_VISIBILITY.NOT_SHOW_ACCESSIBLE_FILTERS
                                this.props.setConfigText('accessibilityFilter.visibility', visibilityValue);
                                isDontShowAccessibleFilters && this.props.setConfigText('accessibilityFilter.defaultSelection', false);
                            }}
                        />
                            <If
                                condition={
                                    this.props.currentConfigCopy.accessibilityFilter.visibility !==
                                    ACCESSIBILITY_FILTER_VISIBILITY.NOT_SHOW_ACCESSIBLE_FILTERS
                                }
                            >
                                <ReactSparkSelectInput
                                    label="Select the room types that guests will see when the Accessible filter is unchecked"
                                    isDisabled={isDisabled}
                                    defaultValue={_.get(this.props, 'currentConfigCopy.accessibilityFilter.unCheckedBehavior')}
                                    values={accessibilityFilterUnchecked.map(v => {
                                        return { key: v.key, label: v.label };
                                    })}
                                    onChange={event => {
                                        const obj = accessibilityFilterUnchecked.find(elem => {
                                            return elem.key === event.target.value;
                                        });
                                        this.props.setConfigText('accessibilityFilter.unCheckedBehavior', _.get(obj, 'key'));
                                    }}
                                />
                                <ConfigurationCheckbox
                                    title="Preselect Accessible Rooms filter"
                                    isDisabled={isDisabled}
                                    code="accessibilityFilter.defaultSelection"
                                    onChange={(event, value) => {
                                        this.props.setConfigText('accessibilityFilter.defaultSelection', !value);
                                    }}
                                    value={_.get(this.props, 'currentConfigCopy.accessibilityFilter.defaultSelection')}
                                />
                            </If>
                    </div>
                </section>
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(3)}
                    style={this.sectionStyleHandler(3)}
                >
                    <div className="col-xs-12">
                        <h4>Use Points Filters</h4>
                        <ReactSparkSelectInput
                            label="Select the placement of the Use Points filter"
                            isDisabled={isDisabled}
                            defaultValue={defaultUsePointsFilterVisibility}
                            values={usePointsFilterVisibility.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            onChange={event => {
                                const selectedOption = usePointsFilterVisibility.find(elem => elem.key === _.get(event, 'target.value'));
                                const visibilityValue = _.get(selectedOption, 'key');
                                const isDontShowUsePointsFilters = visibilityValue === USE_POINTS_FILTER_VISIBILITY.NOT_SHOW_USE_POINTS_FILTERS
                                this.props.setConfigText('usePointsFilter.visibility', visibilityValue);
                                isDontShowUsePointsFilters && this.props.setConfigText('usePointsFilter.defaultSelection', false);
                            }}
                        />
                            <If
                                condition={
                                    _.get(this.props, 'currentConfigCopy.usePointsFilter.visibility') !==
                                    USE_POINTS_FILTER_VISIBILITY.NOT_SHOW_USE_POINTS_FILTERS
                                }
                            >
                                <ReactSparkSelectInput
                                    label="Select the room types that guests will see when the Use Points filter is unchecked"
                                    isDisDisabled={isDisabled}
                                    defaultValue={_.get(this.props, 'currentConfigCopy.usePointsFilter.unCheckedBehavior')}
                                    values={usePointsFilterUnchecked.map(v => {
                                        return { key: v.key, label: v.label };
                                    })}
                                    onChange={event => {
                                        const obj = usePointsFilterUnchecked.find(elem => {
                                            return elem.key === event.target.value;
                                        });
                                        this.props.setConfigText('usePointsFilter.unCheckedBehavior', _.get(obj, 'key'));
                                    }}
                                />
                                <ConfigurationCheckbox
                                    title="Preselect Use Points filter"
                                    isDisabled={isDisabled}
                                    code="usePointsFilter.defaultSelection"
                                    onChange={(event, value) => {
                                        this.props.setConfigText('usePointsFilter.defaultSelection', !value);
                                    }}
                                    value={_.get(this.props, 'currentConfigCopy.usePointsFilter.defaultSelection', false)}
                                />
                            </If>
                    </div>
                </section>
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(4)}
                    style={this.sectionStyleHandler(4)}
                >
                    <div className="col-xs-12">
                        <h4>Hotel Filters</h4>
                        <ConfigurationList
                            fields={hotelFields}
                            isDisabled={isDisabled}
                            positive="Hidden"
                            negative="Visible"
                            makeVisibleFilters={this.props.makeVisibleFilters}
                            makeInvisibleFilters={this.props.makeInvisibleFilters}
                            filterList={_.get(this.props, 'currentConfigCopy.hideHotelListingFilters')}
                            filterType="hideHotelListingFilters"
                        />
                    </div>
                </section>
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(5)}
                    style={this.sectionStyleHandler(5)}
                >
                    <div className="col-xs-12">
                        <h4>Product Filters</h4>
                        <ConfigurationList
                            fields={productFields}
                            isDisabled={isDisabled}
                            positive="Hidden"
                            negative="Visible"
                            makeVisibleFilters={this.props.makeVisibleFilters}
                            makeInvisibleFilters={this.props.makeInvisibleFilters}
                            filterList={_.get(this.props, 'currentConfigCopy.hideProductListingFilters')}
                            filterType="hideProductListingFilters"
                        />
                    </div>
                </section>
            </div>
        );
    }
}

FilterConfiguration.propTypes = {
    children: PropTypes.element,
    currentConfigCopy: PropTypes.shape({}),
    isDisabled: PropTypes.bool,
    makeInvisibleFilters: PropTypes.func,
    makeVisibleFilters: PropTypes.func,
    onIndex: PropTypes.func,
    searchIndex: PropTypes.array,
    setConfigBoolean: PropTypes.func,
    setConfigText: PropTypes.func,
    toggleConfigBoolean: PropTypes.func,
    inContextBeta: PropTypes.bool
};

export default FilterConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/FilterConfiguration.js